<template>
  <b-form-group
    label="Ödeme Ağı"
    label-for="id_card_organization"
  >
    <validation-provider
      #default="{ errors }"
      name="Ödeme Ağı"
      rules="required"
    >
      <v-select
        id="id_card_organization"
        v-model="dataItem.id_card_organization"
        :options="dataList"
        label="title"
        :reduce="item => item.id"
        placeholder="Ödeme Ağı"
        :clearable="false"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'BinNo',
  components: {
    BFormGroup,
    ValidationProvider,
    vSelect,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['binsDefines/dataItem']
    },
    dataList() {
      return this.$store.getters['cardOrganization/dataList']
    },
  },
  created() {
    localize('tr')
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('cardOrganization/getDataList')
    },
  },
}
</script>
